import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Alert } from 'react-bootstrap-5';

type OutOfCreditsAlertProps = {
  singular?: boolean;
  enrichment?: boolean;
}

export default function OutOfCreditsAlert({ singular = true, enrichment = false }: OutOfCreditsAlertProps) {
  if (enrichment) {
    return (
      <Alert className="p-3" variant="danger">
        <div className="d-flex align-items-start gap-2">
          <FontAwesomeIcon className="py-1" icon={faCircleExclamation} />
          <div className="d-flex flex-column">
            <div className="fw-bolder">
              More Credits Required
            </div>
            <div>
              You do not have enough credits to enrich this list.
              Please select a list with fewer properties to begin enrichment.
            </div>
          </div>
        </div>
      </Alert>
    );
  }
  return (
    <Alert className="p-3" variant="danger">
      <div className="d-flex align-items-start gap-2">
        <FontAwesomeIcon className="py-1" icon={faCircleExclamation} />
        <div className="d-flex flex-column">
          <div className="fw-bolder">
            Out of Credits
          </div>
          <div>
            Owners for {singular ? 'this property' : 'these properties'} will not be included due to lack of credits.
          </div>
        </div>
      </div>
    </Alert>
  );
}
